import {uniqueId} from 'lodash'

const columns = [
  {
    name: 'Date',
    prop: 'eventDate',
    type: 'date',
    width: '135px'
  },
  {
    name: 'Project Name',
    prop: 'projectName',
    type: 'string',
    inputFocus: true,
    heightChangeable: true,
    isDynamic: true,
    width: 'minmax(100px, 1fr)'
  },
  {
    type: 'file',
    isArray: true,
    upload: true,
    prop: 'projectFile',
    width: '40px'
  },
  {
    name: 'Comments',
    prop: 'comment',
    type: 'string',
    inputFocus: true,
    heightChangeable: true,
    isDynamic: true,
    width: 'minmax(100px, 2fr)'
  },
  {
    type: 'file',
    isArray: true,
    upload: true,
    prop: 'commentFile',
    width: '40px'
  },
  {
    name: 'Rating',
    prop: 'rating',
    type: 'rating',
    isDynamic: true,
    width: '85px'
  },
]

const prefix = 'contacts_history_column_'
const vendorHistoryTableColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export {vendorHistoryTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/vendorHistoryTable.js